<template>
  <section class="account-panel">
    <h2>账号管理</h2>
    <p>管理已登录过 STN 的 ai-token 账号。角色和启用状态仅对 STN 生效。</p>
    <p v-if="error" role="alert" class="error">{{ error }}</p>
    <p v-if="notice" role="status">{{ notice }}</p>
    <div class="member-actions"><button :disabled="busy" @click="load">刷新</button><span>共 {{ total }} 位成员</span></div>
    <table>
      <thead><tr><th>账号</th><th>姓名</th><th>角色</th><th>状态</th><th>操作</th></tr></thead>
      <tbody>
        <tr v-for="member in members" :key="member.user_id">
          <td>{{ member.username }}</td><td>{{ member.nickname || '—' }}</td>
          <td>{{ member.role === 'admin' ? '管理员' : '普通用户' }}</td>
          <td>{{ member.enabled ? '已启用' : '已禁用' }}</td>
          <td>
            <span v-if="member.protected">初始管理员</span>
            <span v-else-if="member.user_id === auth.user.user_id">当前账号</span>
            <template v-else>
              <button :disabled="busy" @click="update(member, { role: member.role === 'admin' ? 'user' : 'admin' })">{{ member.role === 'admin' ? '设为普通用户' : '设为管理员' }}</button>
              <button :disabled="busy" @click="update(member, { enabled: !member.enabled })">{{ member.enabled ? '禁用' : '启用' }}</button>
            </template>
          </td>
        </tr>
        <tr v-if="!members.length"><td colspan="5">{{ busy ? '正在加载…' : '暂无成员' }}</td></tr>
      </tbody>
    </table>
    <div class="member-actions"><button :disabled="busy || page === 1" @click="page--; load()">上一页</button><span>第 {{ page }} 页</span><button :disabled="busy || page * 20 >= total" @click="page++; load()">下一页</button></div>
    <p>新用户使用已有 ai-token 账号登录 STN 后，会自动加入为普通用户。注册、改密码和全局账号管理请前往 <a href="/ai-token/" target="_blank" rel="noopener">账号中心</a>。</p>
  </section>
</template>
<script>
import { auth } from '../api/auth'
import { apiJSON, jsonBody } from '../api/http'
export default {
  name: 'AccountPanel',
  data: () => ({ auth, members: [], total: 0, page: 1, busy: false, error: '', notice: '' }),
  mounted() { this.load() },
  methods: {
    async load() {
      this.busy = true; this.error = ''
      try { const data = await apiJSON(`/api/admin/members?page=${this.page}`); this.members = data.members; this.total = data.total }
      catch (error) { this.error = error.message }
      finally { this.busy = false }
    },
    async update(member, changes) {
      this.busy = true; this.error = ''; this.notice = ''
      try {
        const updated = await apiJSON(`/api/admin/members/${encodeURIComponent(member.user_id)}`, jsonBody('PATCH', changes))
        this.members = this.members.map(row => row.user_id === member.user_id ? updated : row)
        this.notice = `${member.username} 的访问权限已更新。`
      } catch (error) { this.error = error.message }
      finally { this.busy = false }
    }
  }
}
</script>
<style scoped>
.account-panel { padding: 28px; overflow: auto; }
.account-panel h2 { margin-top: 0; }
.account-panel p { color: #64748b; line-height: 1.7; }
.account-panel table { width: 100%; border-collapse: collapse; background: white; }
.account-panel th, .account-panel td { padding: 14px; text-align: left; border-bottom: 1px solid #e2e8f0; }
.account-panel button { padding: 7px 12px; margin-right: 8px; border: 1px solid #cbd5e1; border-radius: 6px; background: white; cursor: pointer; }
.account-panel button:disabled { opacity: .5; cursor: default; }
.account-panel .error { color: #b91c1c; }
.member-actions { margin: 16px 0; display: flex; gap: 12px; align-items: center; }
</style>
